var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56216 6.49966C2.94054 6.12128 3.53264 6.08689 3.94988 6.39647L4.06942 6.49966L9 11.4298L13.9306 6.49966C14.309 6.12128 14.9011 6.08689 15.3183 6.39647L15.4378 6.49966C15.8162 6.87804 15.8506 7.47014 15.541 7.88738L15.4378 8.00692L9.75363 13.6911C9.37525 14.0695 8.78315 14.1039 8.36591 13.7943L8.24637 13.6911L2.56216 8.00692C2.14595 7.5907 2.14595 6.91588 2.56216 6.49966Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDownIcon);
export default __webpack_public_path__ + "static/media/calendar-down-icon.6b9b40bf4e4c4da5597127fb61d2ba9a.svg";
export { ForwardRef as ReactComponent };